module.exports = __webpack_public_path__ + "img/12.191db15c.png";